<template>
  <article class="upselling">
    <span v-if="breakpoints?.isDesktop" class="closeButton" @click="onClose()">
      {{ $t('shopping_lib.close') }}
      <i class="fas fa-x"></i>
    </span>
    <section class="chooseFlight__mobileList" v-if="!breakpoints?.isDesktop">
      <UpsellingFareCapsule
        v-for="(ffam, indexKey) in upsellingOrdered"
        :class="{ '--active': fareSelected?.id == ffam?.id }"
        :ffam-fare-item="ffam"
        :trip-segment="tripSegment"
        @onFareSelected="onFareSelected(ffam)"
        :key="`ffam_${indexKey}`"
      />
      <article>
        <button class="btn btn-conditions" @click="compareConditions = true">
          {{ $t('compare_conditions') }}
        </button>
      </article>
    </section>
    <section
      class="chooseFlight__faresList"
      v-if="breakpoints?.isDesktop || compareConditions"
    >
      <header class="chooseFlight__faresListHeader">
        <span class="chooseFlight__faresListHeader--title">{{
          $t('compare_conditions')
        }}</span>
        <button @click="onClose" class="chooseFlight__faresListHeader--close">
          <i class="fas fa-close"></i>
        </button>
      </header>
      <upsellingFareItem
        v-for="(ffam, indexKey) in upselling"
        :class="{ '--active': fareSelected?.id == ffam?.id }"
        :key="`ffam_${indexKey}`"
        :ffam-fare-item="ffam"
        :trip-segment="tripSegment"
        @onFareSelected="onFareSelected(ffam)"
        :minimumPriceToCompare="indexKey ? minimumPrice : undefined"
        :hasSomeFareItemPosting="hasSomeFareItemPosting"
      >
      </upsellingFareItem>
    </section>
  </article>
</template>
<script>
import UpsellingFareItem from './upsellingFareItem.vue'
import { useResize } from '../../helpers/useResize.js'
import UpsellingFareCapsule from './upsellingFareCapsule.vue'
import { get } from 'lodash'
export default {
  name: 'uppselling',
  props: {
    upselling: {
      required: false,
    },
    tripSegment: {
      type: Number,
      required: true,
    },
    minimumPrice: {
      type: Object,
      required: false,
    },
  },
  components: {
    UpsellingFareItem,
    UpsellingFareCapsule,
  },
  data: function () {
    return {
      fareSelected: undefined,
      breakpoints: null,
      compareConditions: false,
      upsellingOrdered: [],
    }
  },
  watch: {
    compareConditions: function (compareConditionsOpened) {
      if (compareConditionsOpened) {
        this.$nextTick(() => {
          const termsElement = get(
            document.getElementsByClassName('actionNav__terms'),
            '[0]',
            null
          )
          const fareListElement = get(
            document.getElementsByClassName('chooseFlight__faresList'),
            '[0]',
            null
          )
          if (fareListElement && termsElement) {
            const height = termsElement?.clientHeight
            fareListElement.style.height = `calc(100vh - (6.5rem + ${height}px))`
          }
        })
      }
    },
  },
  mounted: function () {
    this.breakpoints = useResize()
    this.orderedUpselling()
  },
  methods: {
    onClose: function () {
      this.fareSelected = null
      this.$emit('onCloseUpselling')
    },
    onFareSelected: function (ffam) {
      ffam.fare_information.segment_price = get(
        ffam.fare_information,
        `trip_segment_prices[${this.tripSegment}].total`,
        0
      )
      this.fareSelected = ffam
      this.$emit('onFareSelected', this.fareSelected)
    },
    orderedUpselling: function () {
      this.upsellingOrdered = this.upselling.sort((ffamA, ffamB) => ffamA.code.split('_')[0] - ffamB.code.split('_')[0])
    },
  },
  computed: {
    hasSomeFareItemPosting: function () {
      return this.upselling.some((ffam) => ffam.fare_information?.rbd.posting < 9)
    }
  }
}
</script>

<style lang="sass" scoped>
.chooseFlight__faresList
  position: fixed
  display: flex
  flex-direction: column
  top: 3rem
  left: 0
  z-index: 999999
  height: calc(100vh - 6.5rem)
  overflow-y: scroll
  width: 100vw
  background: var(--color-background)
  &Header
    display: flex
    padding: .75rem
    align-items: center
    justify-content: space-between
    &--title
      font-weight: bold
    &--close
      all: unset
      cursor: pointer
@supports (height: calc(100dvh - 6.5rem))
  @media (max-width: 1024)
    .chooseFlight__faresList
      height: calc(100dvh - 6.5rem)
      width: 100dvw

.chooseFlight__mobileList
  display: flex
  flex-direction: column
  gap: .5rem
  padding: .75rem
  padding-top: 0
  .btn-conditions
    width: 100%
    background: var(--color-onPrimary)
.closeButton
  display: flex
  align-items: center
  text-align: end
  padding: .375rem .625rem
  cursor: pointer
  font-weight: 600
  justify-content: end
  font-size: var(--font-size-base)
  border-top: 1px solid var(--color-primary)
  border-bottom: 1px solid var(--color-overlay-20)
  &:hover
    color: var(--color-primary)
  i
    padding-left: .5rem
    padding-top: 0.2rem
    font-size: var(--font-size-sm)

@media (min-width: 1024px)
  .chooseFlight__faresList
    position: initial
    display: -webkit-box
    -webkit-box-pack: center
    height: auto
    width: auto
    flex-direction: row
    padding: .5rem
    gap: .3rem
    &Header
      display: none
    .closeButton
      display: block
</style>
